import Image from 'next/image';
import React from 'react';
import { useTranslations } from '../../../locales/useTranslations';

const PowerBiText = () => {
    const { t } = useTranslations();
    return (
        <section className="about-area ptb-100 powerbi-text">
            {/* Dekorative Hintergrund-Elemente */}
            <div className="powerbi-text__decoration powerbi-text__decoration--top-left"></div>
            <div className="powerbi-text__decoration powerbi-text__decoration--bottom-right"></div>

            <div className="container powerbi-text__container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="about-content">
                            <span className="powerbi-text__badge">
                                {t('powerBi_text_title')}
                            </span>
                            <h2 className="powerbi-text__title">
                                {t('powerBi_text_title2')}
                            </h2>
                            <p className="powerbi-text__description">
                                {t('powerBi_text_description')}
                            </p>
                            <p className="powerbi-text__description">
                                {t('powerBi_text_description2')}
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <div className="about-image powerbi-text__image-wrapper">
                            {/* Dekorative Elemente */}
                            <div className="powerbi-text__image-decoration powerbi-text__image-decoration--top-right"></div>
                            <div className="powerbi-text__image-decoration powerbi-text__image-decoration--bottom-left"></div>

                            {/* Hauptbild-Container */}
                            <div className="powerbi-text__image-card">
                                <Image
                                    src="/images/business-analytics/power-bi/power-bi.svg"
                                    alt="simplify data - Power BI Entwicklung"
                                    width={0}
                                    height={0}
                                    sizes="100vw"
                                    style={{
                                        width: '100%',
                                        height: 'auto'
                                    }}
                                />
                            </div>

                            {/* Floating Elements */}
                            <div className="powerbi-text__floating-badge powerbi-text__floating-badge--primary">
                                Power BI
                            </div>

                            <div className="powerbi-text__floating-badge powerbi-text__floating-badge--secondary">
                                Business Intelligence
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PowerBiText;
